import { ChangeDetectionStrategy, Component, HostBinding, Input } from '@angular/core';

import { EpcotModule } from 'packages/sports/web/app/src/common/epcot-config.service';

export interface IBetslipResultHeaderViewModel {
    resultMessage: string;
    goodLuckMessage: string;
}

@Component({
    selector: 'bs-digital-result-header',
    templateUrl: './result-header.component.html',
    styleUrls: ['./result-header.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false,
})
export class ResultHeaderComponent {
    @Input() viewModel: IBetslipResultHeaderViewModel;
    @HostBinding('class') className = 'betslip-result-header';
    module = EpcotModule.Betslip;

    get notificationMessage(): string {
        return `${this.viewModel.resultMessage} ${this.viewModel.goodLuckMessage}`;
    }
}
